import { WorkspacePlanType } from '.cache/__types__';
import { useActorPlanQuery } from './actor-plan.graphql';

const MAX_PERSONAL_CARD_LIMIT_FREE_PLAN = 2;

interface ActorPlan {
  /**
   * The loading state for the billing subscription data
   */
  loading: boolean;
  /**
   * The maximum number of personal cards this user can create. If the user is not part of any
   * subscription (premium or team) this will be `FREE_PLAN_MAX_PERSONAL_CARDS`.
   */
  maxPersonalCards: number;
  /**
   * The type of subscription plan the user is on.
   */
  planType: 'free' | 'premium' | 'team';
  /**
   * The display name of the plan the user has.
   */
  planName: string;
}

export const useActorPlan = (): ActorPlan => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const { loading, data } = useActorPlanQuery({
    variables: {
      timezone,
    },
    fetchPolicy: 'cache-and-network',
  });

  const { max_personal_cards, type, name } = data?.actor?.plan || {};

  // Weird behavior from enums, this is a workaround until I can fix the schema generation.
  // This will allow either.
  function transformPlanType(type: WorkspacePlanType) {
    if (type === 'PREMIUM') {
      return 'premium';
    }
    if (type === 'TEAM') {
      return 'team';
    }
    if (type === 'FREE') {
      return 'free';
    }

    return type;
  }

  return {
    loading,
    planType: type ? transformPlanType(type) : 'free',
    planName: name || 'Free plan',
    maxPersonalCards: max_personal_cards || MAX_PERSONAL_CARD_LIMIT_FREE_PLAN,
  };
};
